// todo: find an up-to-date local storage npm package
// the following memory storage code was taken from local-storage npm,
// since it helps create a stub memory storage when it's not available
// (in our case the web worker doesn't have access to window or window.localStorage)
// https://github.com/bevacqua/local-storage/blob/master/stub.js
let ms = {};
function getItem(key) {
    return key in ms ? ms[key] : null;
}
function setItem(key, value) {
    ms[key] = value;
    return true;
}
function removeItem(key) {
    var found = key in ms;
    if (found) {
        return delete ms[key];
    }
    return false;
}
function clear() {
    ms = {};
    return true;
}

const memoryStorage = { getItem, setItem, removeItem, clear };

const ls = typeof window === 'undefined' ? memoryStorage : window.localStorage;

const PREFIX = (() => {
    try {
        if (window !== undefined && window.location !== undefined) {
            return window.location.host;
        }
        return '';
    } catch (err) {
        return '';
    }
})();

export default class StorageService {
    public static get(key: string): any {
        return ls.getItem(PREFIX + key);
    }

    public static set(key: string, value: any) {
        ls.setItem(PREFIX + key, value);
    }

    public static remove(key: string) {
        ls.removeItem(PREFIX + key);
    }

    public static clear() {
        ls.clear();
    }
}
